/*
 * Created: 2019-05-23 14:37:36
 * Author : zc
 * Email : 591074801@qq.com
 * -----
 * Description:
 */

import request from '@/utils/request';

/**获取客户等级列表 */
export const customerLevelList = () => {
  return request.get('/api/Customer/Level/List', {});
};

/**获取客户等级列表 判断权限 */
export const customerNoPermissionLevelList = () => {
  return request.get('/api/Customer/Level/All', {});
};

/**删除客户等级 */
export const deleteCustomerLevel = function(id: string) {
  let url = `/api/Customer/Level/${id}`;
  return request.del(url, {});
};

/**编辑或者新增客户等级 */
export const addOrEditCustomerLevel = function(level: any) {
  let param = Object.assign({}, level);
  let url = '/api/Customer/Level/CreateOrEdit';
  return request.post(url, param);
};

/**资金账户列表 */
export const accountList = function(formData?: any) {
  let url = '/api/Customer/Account/List';
  return request.get(url, {
    ...formData
  });
};

/**导出资金账户列表 */
export const accountExport = function(formData?: any) {
  let url = '/api/Customer/Account/export';
  return request.download(url, { ...formData });
};

/**客户资金账户列表 */
export const accountMoneyList = function(customerId: string) {
  let url = `/api/Customer/${customerId}/Account`;
  return request.get(url, {});
};

/**充值 */
export const accountRecharge = function(formData?: any) {
  let url = '/api/Customer/Account/recharge';
  return request.post(url, {
    ...formData
  });
};

/**资金收支明细 */
export const accountHistories = function(formData?: any) {
  let url = '/api/Customer/Account/Histories';
  return request.get(url, {
    ...formData
  });
};

export const getOperations = [
  { name: '充值', key: 'Recharge', value: 1 },
  { name: '扣款', key: 'Deduct', value: 2 },
  { name: '充值撤销', key: 'UndoRecharge', value: 3 },
  // { name: '转账', key: 'Transfer' ,value:4},
  { name: '下单冻结', key: 'OrderFreeze', value: 5 },
  { name: '取消扣款', key: 'CancelDedut', value: 6 },
  { name: '取消冻结', key: 'CancelFreeze', value: 7 },
  { name: '冻结金额差值', key: 'FreezeDifference', value: 8 }
];

/**获取操作类型的名称 */
export const getOpertaionName = function(type: string) {
  for (const index in getOperations) {
    const item = getOperations[index];
    if (item.key == type) {
      return item.name;
    }
  }
  return '';
};

export const getRechargeTypeOpts = [
  { name: '充值', key: 'Recharge', value: 1 },
  { name: '返点充值', key: 'RebateRecharge', value: 3 },
  { name: '余额变更', key: 'ChangeBalance', value: 2 }
];

export const getRechargeTypeName = function(type: string) {
  for (const index in getRechargeTypeOpts) {
    const item = getRechargeTypeOpts[index];
    if (item.key == type) {
      return item.name;
    }
  }
  return '';
};

/**客户资金账户列表 */
export const accountHistoryDetail = function(id: string) {
  let url = `/api/Customer/Account/History/${id}`;
  return request.get(url, {});
};

/**客户资金账户列表 */
export const accountUndo = function(formData: any) {
  let url = '/api/Customer/Account/undo';
  return request.post(url, {
    ...formData
  });
};

/**禁用客户，启用客户 */
export const activeCustomer = function(id: string) {
  return request.put(`/api/Customer/${id}/active`);
};

/**获取客户列表 */
export const customerList = function(param?: any) {
  return request.get(`/api/Customer/List`, { ...param });
};

/**获取客户列表 不判断权限 */
export const customerNoPermissionList = function(param?: any) {
  return request.get(`/api/Customer/All`, { ...param });
};

/**获取客户 */
export const getCustomer = function(id: string) {
  return request.get(`/api/Customer/${id}`);
};
/**新增，修改客户 */
export const createOrEdit = function(formData: any) {
  return request.post('/api/Customer/CreateOrEdit', formData);
};

/**获取操作记录 */
export const getLogs = function(id: string) {
  return request.get(`/api/Customer/${id}/logs`);
};

/**客户手机验证唯一性 */
export const checkPhoneNumberExist = function(param: any) {
  return request.get('/api/Customer/CheckPhoneNumberExist', { ...param });
};

/**获取客户折扣 */
export const getDiscount = function(id: string) {
  return request.get(`/api/Customer/Discount/${id}`);
};

/**修改客户折扣 */
export const editDiscount = function(formData?: any) {
  return request.put(`/api/Customer/Discount`, formData);
};

/**修改客户折扣状态 */
export const discountStatus = function(formData?: any) {
  return request.put(`/api/Customer/Discount/Status`, formData);
};
/**新增客户折扣 */
export const createDiscount = function(id: string, formData?: any) {
  return request.post(`/api/Customer/${id}/Discounts`, formData);
};
/**修改充值状态 */
export const rechargeStatus = function(formData?: any) {
  return request.post(`/api/Customer/Account/Recharge/status`, formData);
};
/**修改充值 */
export const editRecharge = function(formData?: any) {
  return request.put(`/api/Customer/Account/recharge`, formData);
};
// 删除充值
export const delRecharge = function(id: string) {
  return request.del(`/api/Customer/Account/Recharge/${id}`);
};
